<template>
  <div>
    <div class="fixed">
      <el-row class="container">
        <el-col :span='6' style="line-height:60px">
          <img src="@/assets/logo.png" style="width:220px;vertical-align:middle" alt="">
        </el-col>
        <el-col :span='18' class="top-right">
          <router-link v-for="(item,index) in routes" :key='index' :to='item.meta.redirect?item.meta.redirect:item.path'
            :class="$route.meta.parent==item.path?'active':''" v-show="!item.meta.hidden">{{item.meta.title}}
          </router-link>
          <span size='medium' class="join" @click="onJoin">加入我们</span>
        </el-col>
      </el-row>
    </div>

    <router-view style="margin-top:60px"></router-view>
    <div class="bottom">
      <div class="border-bottom padding-bottom-sm">
        <div class="container flex justify-between">
          <div>
            <p><img src="@/assets/icon-footer.png" alt=""></p>
            <p>联系电话：17558862682赵老师</p>
            <p>电子邮箱：jsiotservice@163.com</p>
            <p>协会地址：南京市秦淮区悦动新门西9栋101</p>
          </div>
          <div>
            <p class="text-center"><img src="@/assets/img-qr.png" alt=""></p>
            <p style="width:170px;line-height:20px" class="text-sm">关注“江苏省物联网服务协会”公众号，第一时间了解行业咨询</p>
          </div>
        </div>
      </div>
      <p class="text-center text-sm lh-xs">Copyright © 2020-2021 科舸物联科技有限公司 - 版权所有 - 苏ICP备2021005232号-3</p>
    </div>
  </div>
</template>

<script>
  export default {
    components: {

    },
    data() {
      return {
        
      };
    },
    computed:{
      routes(){
        return this.$store.state.routes
      }
    },
    mounted() {

    },
    methods: {
      onJoin() {
        this.$router.push('/joinUs')
      }
    }
  }
</script>
<style scoped>
  a {
    text-decoration: none
  }

  .fixed {
    position: fixed;
    z-index: 99999;
    /* height; */
    width: 100%;
    top: 0;
    background: #ffffff;
    box-shadow: 0 2px 4px 0 #dfdfdf
  }

  .join {
    display: inline-block;
    background: #C2000B;
    color: #ffffff !important;
    height: 30px;
    line-height: 30px;
    width: 80px;
    text-align: center;
    cursor: pointer;
  }

  .top-right {
    font-size: 15px;
    /* text-align: right; */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  a {
    margin-left: 10px;
    line-height: 60px;
    color: #18181A;
  }

  .top-right>a:hover {
    cursor: pointer;
    color: #C2000B;
  }

  .el-button {
    margin-left: 10px;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
  }

  .bottom {
    background: #191A1E;
    color: #ffffff;
    height: 322px;
    /* margin-top: 60px; */
  }

  .bottom .container p:nth-child(1) {
    font-size: 24px;
    margin-top: 50px;
  }

  .bottom .container p:nth-child(2) {
    font-size: 14px;
  }

  .bottom .container p:nth-child(3) {
    font-size: 14px;
  }

  .bottom-p {
    text-align: center;
    font-size: 13px;
    line-height: 40px;
    background: #383844;
    color: #ffffff;
    margin: 0 auto
  }

  .active {
    color: #C2000B !important;
  }
</style>